import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { withRouter } from 'react-router'
import FacebookLogin from 'react-facebook-login'
import GoogleLogin from 'react-google-login'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { facebookAuth, googleAuth } from '../../common/auth/actions'
import { facebookCredentials, roles } from '../../common/config'

class SocialAuth extends React.Component {
  handleFacebook = (response) => {
    const { facebookAuth, registeringUser, currentLesson, currentTest } = this.props

    const data = {
      ...registeringUser,
      ...response,
    }

    if (registeringUser) {
      if (registeringUser.role === roles.USER) {
        data.lesson = currentLesson
      } else if (registeringUser.role === roles.TEACHER) {
        data.test = currentTest
      }  
    }

    facebookAuth(data)
  }

  handleGoogle(response) {
    const { googleAuth, registeringUser, currentLesson, currentTest } = this.props

    const data = {
      ...registeringUser,
      accessToken: response.accessToken,
      id: response.googleId,
      email: response.profileObj.email,
      name: response.profileObj.name,
      picture: response.profileObj.imageUrl,
    }

    if (registeringUser) {
      if (registeringUser.role === roles.USER) {
        data.lesson = currentLesson
      } else if (registeringUser.role === roles.TEACHER) {
        data.test = currentTest
      }
    }

    googleAuth(data)
  }

  render() {
    const { facebookLabel, googleLabel } = this.props

    return (
      <React.Fragment>
        {/*
        <FacebookLogin
          appId={facebookCredentials.clientID}
          fields="name,email,picture"
          cssClass="social-button facebook-button"
          icon="fa-facebook"
          textButton={facebookLabel}
          redirectUri="https://vobo.io/app"
          callback={response => this.handleFacebook(response)}
        />
        */}
        <GoogleLogin
          clientId="863013698061-4dcq9sc6vd3bmoer9dhkilep66frvu76.apps.googleusercontent.com"
          className="social-button google-button"
          icon="fa-google"
          buttonText={googleLabel}
          onSuccess={(response) => this.handleGoogle(response)}
          onFailure={() => {}}
        >
          <FontAwesomeIcon icon={['fab', 'google']} />
          <span>{googleLabel}</span>
        </GoogleLogin>
      </React.Fragment>
    )
  }
}

SocialAuth.defaultProps = {
  registeringUser: {},
}

SocialAuth.propTypes = {
  facebookAuth: PropTypes.func.isRequired,
  googleAuth: PropTypes.func.isRequired,
  facebookLabel: PropTypes.string.isRequired,
  googleLabel: PropTypes.string.isRequired,
  registeringUser: PropTypes.object,
}

const enhance = compose(
  withRouter,
  connect(state => ({
    registeringUser: state.users.registeringUser,
    currentTest: state.tests.currentTest,
    currentLesson: state.lessons.currentLesson,
  }), { facebookAuth, googleAuth }),
)

export default enhance(SocialAuth)



// WEBPACK FOOTER //
// ./src/browser/components/SocialAuth.js